import { EditComponent } from "../../app-lite/table/cell-components/actions/edit.component";

export function VendorOrdersCtrl(
  $state,
  $scope,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showVendorOrders = !!$scope.orders.length;
  $scope.tableCacheKey    = 'vendorOrders';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'order_number',
        header: {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER'),
        },
      },
      {
        field : 'order_date',
        header: { text: $translate.instant('GENERAL_SPACE.FIELD.DATE') },
        pipe  : 'globalDate',
      },
      {
        field : 'due_date',
        header: { text: $translate.instant('PURCHASE_ORDER_SPACE.DUE_DATE') },
        pipe  : 'globalDate',
      },
      {
        field : 'note',
        header: { text: $translate.instant('INSPECTIONS_SPACE.COMMENT') },
      },
      {
        field : 'status',
        header: { text: $translate.instant('GENERAL_SPACE.FIELD.STATUS') },
        pipe  : 'purchaseOrderStatus',
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
        },
        pipe: 'globalCurrency',
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => $scope.viewOrder(event),
            },
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      },
    ],
    empty: {
      text: $translate.instant(
        'QUERY_DROPDOWN_SPACE.GRID.NO_STOCK_ORDERS_FOUND'
      ),
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [5, 10, 25, 50],
      queryCount: () =>
        workshopAPI.get('/vendors/purchase_order_count', [
          $scope.vendor.id,
          '*',
        ]),
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'order_date'
    })
  };

  $scope.getOrders = (params) => {
    return workshopAPI.get('/vendors/purchase_order_list', [
      $scope.vendor.id,
      params.offset,
      params.pageSize,
      '*',
      params.field,
      params.direction,
    ]).then(orders => {
      $scope.orders = orders;

      return orders;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewOrder(event.row);
  };

  $scope.viewOrder = function (order) {
    $state.go('app.purchase-order', {
      vendor_id: order.vendor_id,
      id       : order.id,
    });
  };
}
